module.exports = __webpack_public_path__ + "static/media/loader.2ed2451b.gif";